/* eslint-disable jsx-a11y/alt-text */
import { Layout, Radio, Select, DatePicker } from "antd";
import { Content } from "antd/es/layout/layout";
import axios from "axios";
import dayjs from "dayjs";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Dots } from "react-activity";
import styled from "styled-components";

import { Button } from "@components/Button";
import Header from "@components/Header";
import { InnerContents } from "@components/InnerContents";
import { SideMenu } from "@components/SideMenu";
import { Text } from "@components/Text";
import { COLOR_GREEN, COLOR_GREY_1, COLOR_WHITE } from "@static/COLORS";
import { CONTENT_STYLES } from "@static/CONTENT_STYLES";
import { MENU_SIZE } from "@static/SIZE";
import { handleExportDetails } from "@utils/exportDetails";
import { handleExportOverview } from "@utils/exportOverview";
import { getAuthUserProfile } from "@utils/getAuthUserProfile";
import { getUserExtraCustomers } from "@utils/getUserExtraCustomers";
import { sleep } from "@utils/sleep";

import { TableDetails } from "./TableDetails";
import { TableOverview } from "./TableOverview";

const SectionMainAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  background: ${COLOR_WHITE};
  padding: 8px;
  border-radius: 6px;
  /* gap: 16px; */
  height: 50px;
  box-sizing: border-box;
`;

const LineHorizontal = styled.div`
  width: 1px;
  height: 16px;
  background: ${COLOR_GREY_1};
  margin-left: 16px;
  margin-right: 16px;
`;

const SectionActionLogType = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SectionActionSelectScreen = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
`;

const SectionActionDateRange = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
`;

const ContainerMediaLogs = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: ${COLOR_WHITE};
  border-radius: 6px;
`;

const { Group: RadioGroup } = Radio;
const { RangePicker } = DatePicker;

const RADIO_OPTIONS = [
  { label: "Overview", value: "overview" },
  { label: "Details", value: "details" },
];

const URL_PATH = {
  overview: "/get-overview-media-logs",
  details: "/get-details-media-logs",
};

const { REACT_APP_API_MEDIA_LOG_ENDPOINT } = process.env;

export default () => {
  const allCustomers = getUserExtraCustomers();
  const authUserProfile = getAuthUserProfile();

  const user_type = _.get(authUserProfile, ["user_type"]);
  const category_customer_id = _.get(authUserProfile, ["category_customer_id"]);

  const [isLoading, setIsLoading] = useState(false);

  const [dataList, setDataList] = useState([]);

  const [selectedRadio, setSelectedRadio] = useState(RADIO_OPTIONS[0].value);
  const [selectedScreens, setSelectedScreens] = useState(null);

  const [selectedMedia, setSelectedMedia] = useState(null);
  const [selectedDateRange, setSelectedDateRange] = useState([
    dayjs().subtract(6, "month"),
    dayjs(),
  ]);

  const [screenOptions, setScreenOptions] = useState([]);
  const [mediaOptions, setMediaOptions] = useState([]);

  const [detailTotalPage, setDetailTotalPage] = useState(1);
  const [detailCurrentPage, setDetailCurrentPage] = useState(1);

  const handleSearch = async ({ type = "overview" }) => {
    try {
      const subpath = _.get(URL_PATH, [selectedRadio]);
      const url = `${REACT_APP_API_MEDIA_LOG_ENDPOINT}/${subpath}`;
      const resp = await axios({
        method: "post",
        url: url,
        data: {
          startDate: selectedDateRange[0],
          endDate: selectedDateRange[1],
          deviceId: selectedScreens,
          mediaId: selectedMedia,
          customerList: allCustomers,
        },
      });

      const respData = _.get(resp, ["data"]);
      console.log("respData :>> ", respData);
      if (_.get(respData, ["status"])) {
        const inSideKey = type === "overview" ? ["result"] : ["result", "data"];
        const results = _.chain(respData).get(inSideKey).value();
        setDataList(results);
        if (type === "overview") {
          const totalPages = _.chain(respData)
            .get(["result", "pagination", "totalPages"], 1)
            .value();
          setDetailTotalPage(totalPages);
        }
      }
    } catch (error) {
      console.log("error :>> ", error);
    }
  };

  const handleExportExcel = async ({ type }) => {
    setIsLoading(true);
    if (type === "overview") {
      await handleExportOverview({ data: dataList });
      console.log("export overview :>> ");
    } else {
      await handleExportDetails({
        totalPage: detailTotalPage,
        startDate: selectedDateRange[0],
        endDate: selectedDateRange[1],
        deviceId: selectedScreens,
        mediaId: selectedMedia,
        customerList: allCustomers,
      });
      console.log("export details :>> ");
    }
    setIsLoading(false);
  };

  const handleChangeTable = async ({ value }) => {
    setIsLoading(true);
    setSelectedRadio(value);
    setSelectedScreens(null);
    setSelectedMedia(null);
    setDataList([]);
    await sleep({ sec: 1 });
    setIsLoading(false);
    setDetailCurrentPage(1);
  };

  const initial = async () => {
    try {
      const resp = await axios({
        method: "post",
        url: `${REACT_APP_API_MEDIA_LOG_ENDPOINT}/get-dropdown-media-logs`,
        data: {
          customerList: allCustomers,
        },
      });
      const respData = _.get(resp, ["data"]);
      if (_.get(respData, ["status"])) {
        const resultScreenOptions = _.get(respData, [
          "result",
          "resultScreenOptions",
        ]);
        const resultMediaOptions = _.get(respData, [
          "result",
          "resultMediaOptions",
        ]);
        setScreenOptions(resultScreenOptions);
        setMediaOptions(resultMediaOptions);
      }
      console.log("resp :>> ", resp);
    } catch (error) {
      console.log("error :>> ", error);
    }
  };

  useEffect(() => {
    initial();
  }, []);

  return (
    <Layout hasSider>
      <SideMenu />
      <Layout style={{ marginLeft: MENU_SIZE }}>
        <Header />
        <Content style={CONTENT_STYLES}>
          <InnerContents style={{ overflow: "hidden" }}>
            <SectionMainAction>
              <SectionActionLogType>
                <Text style={{ marginLeft: 8 }} fontWeight="500">
                  Log type :
                </Text>
                <RadioGroup
                  disabled={isLoading}
                  options={RADIO_OPTIONS}
                  value={selectedRadio}
                  optionType="button"
                  onChange={(e) => {
                    handleChangeTable({ value: e.target.value });
                    // {
                    //   setDetailCurrentPage(1);
                    //   setSelectedRadio(e.target.value);
                    // }
                  }}
                />
              </SectionActionLogType>
              <LineHorizontal />
              <SectionActionSelectScreen>
                <Text fontWeight="500">Select Screen :</Text>
                <Select
                  disabled={isLoading}
                  allowClear
                  size="middle"
                  showSearch
                  placeholder="Select a screen"
                  optionFilterProp="children"
                  style={{ width: "200px" }}
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  value={selectedScreens}
                  options={screenOptions}
                  onChange={(e) => setSelectedScreens(e ?? null)}
                />
              </SectionActionSelectScreen>
              <LineHorizontal />
              <SectionActionSelectScreen>
                <Text fontWeight="500">Select Media :</Text>
                <Select
                  disabled={isLoading}
                  allowClear
                  size="middle"
                  showSearch
                  placeholder="Select a Media"
                  optionFilterProp="children"
                  style={{ width: "200px" }}
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  value={selectedMedia}
                  options={mediaOptions}
                  onChange={(e) => setSelectedMedia(e ?? null)}
                />
              </SectionActionSelectScreen>
            </SectionMainAction>
            <SectionMainAction>
              <SectionActionDateRange>
                <Text fontWeight="500" style={{ marginLeft: 8 }}>
                  Date Range :
                </Text>
                <RangePicker
                  style={{ width: "300px" }}
                  allowClear={true}
                  onChange={(e) => {
                    const dateRange = e
                      ? e
                      : [dayjs().subtract(6, "month"), dayjs()];
                    setSelectedDateRange(dateRange);
                  }}
                  value={selectedDateRange}
                />
              </SectionActionDateRange>
              <LineHorizontal />
              <Button
                onClick={() => handleSearch({ type: selectedRadio })}
                type="submit"
                color={COLOR_GREEN}
                fontColor={COLOR_WHITE}
                fontSize="14px"
                padding="2px 20px"
              >
                Search
              </Button>
              <div style={{ margin: "0px 4px" }} />
              <Button
                onClick={() => handleExportExcel({ type: selectedRadio })}
                type="submit"
                color={COLOR_GREEN}
                fontColor={COLOR_WHITE}
                fontSize="14px"
                padding="2px 20px"
              >
                Export
              </Button>
            </SectionMainAction>
            <ContainerMediaLogs>
              {!isLoading ? (
                selectedRadio === "overview" ? (
                  <TableOverview
                    dataList={dataList}
                    setDataList={setDataList}
                    selectedScreens={selectedScreens}
                    selectedMedia={selectedMedia}
                    selectedDateRange={selectedDateRange}
                  />
                ) : (
                  <TableDetails
                    detailCurrentPage={detailCurrentPage}
                    setDetailCurrentPage={setDetailCurrentPage}
                    detailTotalPage={detailTotalPage}
                    setDetailTotalPage={setDetailTotalPage}
                    dataList={dataList}
                    setDataList={setDataList}
                    selectedScreens={selectedScreens}
                    selectedMedia={selectedMedia}
                    selectedDateRange={selectedDateRange}
                  />
                )
              ) : (
                <LoadingContainer>
                  <Dots />
                </LoadingContainer>
              )}
            </ContainerMediaLogs>
          </InnerContents>
        </Content>
      </Layout>
    </Layout>
  );
};
